import { cn } from '@/lib/utils'

/**
 * Shared styling tokens for all form fields (inputs, selects, comboboxes)
 * to ensure visual consistency across the application
 */
export const fieldTokens = {
	// Base field styling
	base: "h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium",
	
	// Focus states
    focus: "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0",
	
	// Disabled states (matches email field - no opacity, same colors)
	disabled: "disabled:cursor-not-allowed disabled:bg-muted/70 disabled:text-foreground",
	
	// Placeholder styling
	placeholder: "placeholder:text-muted-foreground",
	
	// Combined base classes for inputs
    input: "h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:bg-muted/70 disabled:text-foreground",
	
	// Combined classes for combobox triggers (same as input but with different interaction states)
    combobox: "h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:bg-muted/70 disabled:text-foreground",
}

/**
 * Helper function to combine field tokens with additional classes
 */
export const getFieldClasses = (variant: keyof typeof fieldTokens, additionalClasses?: string) => {
	return cn(fieldTokens[variant], additionalClasses)
}
